import { render, staticRenderFns } from "./Anniversary.vue?vue&type=template&id=6b64e06e&scoped=true"
import script from "./Anniversary.vue?vue&type=script&lang=js"
export * from "./Anniversary.vue?vue&type=script&lang=js"
import style0 from "./Anniversary.vue?vue&type=style&index=0&id=6b64e06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64e06e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
